export default function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/de10d19b09a673f58400ae6ee324d714.jpg"
          alt="Luxury Smart Home Automation Florida"
          title="Premium Home Automation Control4 Savant RTI Brilliant"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative h-full max-w-[1400px] mx-auto px-8 flex items-center">
        <div className="max-w-2xl">
          <p className="text-[11px] tracking-[0.3em] uppercase text-[#4A90E2] mb-6 font-light">
            RDM SECURITY
          </p>
          <h1 className="text-7xl font-serif text-white leading-tight mb-6">
            <strong>Intelligent Living</strong><br />
            Redefined<br />
            For Modern Estates
          </h1>
          <p className="text-lg font-light text-white/80 mb-10 max-w-lg leading-relaxed">
            Seamlessly integrate <strong>Control4, Savant, RTI, and Brilliant</strong> systems with <strong>enterprise-grade infrastructure</strong> in <strong>South East Florida</strong> and <strong>Tampa</strong>
          </p>
          <div className="flex gap-4">
            <a
              href="#blueprint"
              className="px-8 py-4 bg-black text-white text-sm font-medium tracking-wide rounded-full hover:bg-black/80 transition-all cursor-pointer whitespace-nowrap"
            >
              Upload Blueprint
            </a>
            <a
              href="#platforms"
              className="px-8 py-4 border-2 border-white text-white text-sm font-medium tracking-wide rounded-full hover:bg-white hover:text-black transition-all cursor-pointer whitespace-nowrap"
            >
              Explore Platforms
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-xs text-white/60 tracking-wider">SCROLL</span>
        <i className="ri-arrow-down-line text-white/60 text-xl"></i>
      </div>
    </section>
  );
}
